import { cn } from '@/utils/tailwind';

interface PopoverMenuButtonItemProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  dataTestId?: string;
  icon?: React.ReactNode;
  isDestructive?: boolean;
  isDisabled?: boolean;
  isVisible?: boolean;
  text?: string;
}

/**
 * Base `button` for the popover menu button.
 *
 * @example
 * <PopoverMenuButtonItem
 *   icon={<IconTrash />}
 *   onClick={() => { console.log('delete'); }}
 *   text="Delete"
 *   isDestructive
 * />
 */
const PopoverMenuButtonItem: React.FC<PopoverMenuButtonItemProps> = ({
  dataTestId = 'PopoverMenuItem',
  icon,
  isDisabled,
  isDestructive,
  isVisible = true,
  text,
  className,
  ...rest
}) => {
  if (!isVisible) {
    return null;
  }

  return (
    <button
      data-testid={dataTestId}
      disabled={isDisabled}
      className={cn(
        'hover:bg-th-bg! flex w-full! items-center justify-start gap-3 px-4! py-3! text-left font-medium! first:pt-6! last:pb-6!',
        {
          'cursor-pointer': !isDisabled,
          'cursor-not-allowed! opacity-50!': isDisabled,
          'text-feedback-error-base!': isDestructive && !isDisabled,
          'dark:text-disabled-contrast! text-gray-400!': isDisabled,
          'text-brand-navy! dark:text-contrast!': !isDestructive && !isDisabled,
        },
        className,
      )}
      {...rest}
    >
      {icon}
      {text}
    </button>
  );
};

export default PopoverMenuButtonItem;
